import styled from "styled-components";

const color = {
    default: {
        primary: 'linear-gradient(-180deg, #37AEE2 0%, #1E96C8 100%)',
        success: 'linear-gradient(0deg, rgba(15,151,63,1) 0%, rgba(20,167,62,1) 100%)',
        danger: 'linear-gradient(0deg, #b31217 51%, #b31217 100%)'
    },
    hover: {
        primary: 'linear-gradient(-180deg, #1D95C9 0%, #17759C 100%)',
        success: 'linear-gradient(0deg, rgba(15,151,63,1) 0%, rgba(20,167,62,1) 100%)',
        danger: 'linear-gradient(0deg, #85040c 0%, #85040c 100%)'
    }
};

export const StyledButton = styled.div`
    padding: 4px 8px;
    margin: 0 2px;
    font-size: 14px;
    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #fff;
    background-image: ${props => props.variant ? color.default[props.variant] : color.default.primary};
    border-radius: 5px;
    cursor: pointer;
    &:hover {
        background-image: ${props => props.variant ? color.hover[props.variant] : color.hover.primary};
    }
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`;

export const StyledPagination = styled.nav`
    width: 90%;
    margin: 10px auto;
    height: auto;
`

export const StyledPaginationList = styled.li`
    max-width: 40px;
`
